import { IOfferScopeCrudModalLang } from '../../../types/lang'

export const offerScopeCrudModalLang: IOfferScopeCrudModalLang = {
	offer_scope_crud_modal: {
		title_create: 'Create offer scope',
		title_edit: 'Edit offer scope',
		title_remove_single: 'Remove <span>offer scope</span>',
		title_notes_view: 'View notes for offer scope',
		title_notes_edit: 'Edit notes for offer scope',
		field_name_label: 'Name',
		field_name_placeholder: 'Name',
		field_cap_label: 'Cap',
		field_cap_placeholder: 'Cap',
		field_cap_type_label: 'Cap Type',
		field_cap_type_placeholder: 'Cap Type',
		field_status_label: 'Status',
		field_status_placeholder: 'Status',
		field_notes_label: 'Notes',
		field_notes_placeholder: 'Notes',
		msg_remove_confirm: 'Are you sure?',
		btn_create: 'Create',
		btn_update: 'Save',
		btn_remove: 'Remove',
		btn_close: 'Close'
	}
}